import { cn } from "@/libraries/cn";
import isEqual from "fast-deep-equal";
import { memo } from "react";
import { useDropzone } from "react-dropzone";
import type { DropzoneOptions } from "react-dropzone";

interface DropzoneFileProps extends React.ComponentProps<"div"> {
	dropzoneOptions: DropzoneOptions;
	inputProps?: React.ComponentProps<"input">;
}

const DropzoneFile = (props: DropzoneFileProps) => {
	const { inputProps, dropzoneOptions, children, className, ...divProps } =
		props;

	const {
		getRootProps,
		getInputProps,
		isDragActive,
		isDragAccept,
		isDragReject,
	} = useDropzone(dropzoneOptions);

	return (
		<div
			{...getRootProps(divProps)}
			className={cn(className, {
				"border-2 border-dashed": isDragActive,
				"border-primary": isDragAccept,
				"border-danger-300": isDragReject,
			})}
		>
			<input {...getInputProps(inputProps)} />
			{children}
			{isDragActive ? (
				<div
					className={cn(
						"absolute inset-0 flex items-center justify-center rounded-md",
						{
							"bg-primary/20": isDragAccept,
							"bg-danger-300/20": isDragReject,
						},
					)}
				>
					{isDragAccept ? (
						<p className="text-3xl font-semibold text-primary">
							Drop files here
						</p>
					) : null}
					{isDragReject ? (
						<p className="text-3xl font-semibold text-danger-300">
							File type not allowed
						</p>
					) : null}
				</div>
			) : null}
		</div>
	);
};

export default memo(DropzoneFile, isEqual);
